import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import 'rxjs/add/operator/map';

import { Configuration } from '../configuration';
import { NetworkError, StreamDto } from '../model';
import { NetworkErrorWatcherService } from '../network-error-watcher.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StreamApi {
  protected basePath = '/api/stream';
  public defaultHeaders = new HttpHeaders();
  public configuration: Configuration = new Configuration();

  constructor(protected errorWatcher: NetworkErrorWatcherService,
              protected httpClient: HttpClient, @Optional() configuration: Configuration) {
    if (configuration) {
      this.configuration = configuration;
    }
  }

  private errorHandle(error: any) {
    if (error.status === 401) {
      this.errorWatcher.broadcastError(error.status);
    }
    const errorBody = JSON.parse(error._body);
    let errorCode = null;

    if (errorBody.error !== undefined && errorBody.error.errorCode !== undefined) {
      errorCode = errorBody.error.errorCode;
    }

    return throwError(new NetworkError(error.status, errorCode, errorBody));
  }

  public getStreamData(): Observable<any> {
    let headers = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }

    const httpHeaderAccepts: string[] = [
      'application/xml',
      'application/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.get<StreamDto>(`${this.basePath}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers
      }
    ).pipe(
      catchError(this.errorHandle)
    );
  }

  public updateStreamData(body: StreamDto, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error('Body cannot be empty.');
    }

    let headers = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken = typeof this.configuration.accessToken === 'function'
        ? this.configuration.accessToken()
        : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }

    const httpHeaderAccepts: string[] = [
      'application/xml',
      'application/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const consumes: string[] = [
      'application/json',
      'application/xml'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<any>(`${this.basePath}`,
      body,
      {
        withCredentials: this.configuration.withCredentials,
        headers,
        observe,
        reportProgress
      }
    ).pipe(
      catchError(this.errorHandle)
    );
  }
}
